<template>
	<div class="preview" :style="dataStyle">
		<div v-if="scope.row.thumbUrl || scope.row.videoUrl">
			<div v-if="scope.row.videoUrl" class="video">
				<img src="~@/assets/richText/video.png" alt="" class="video" />
				<div class="controls" @click="videoPreview(scope.row.videoUrl)">
					<i class="el-icon-video-play"></i>
				</div>
			</div>
			<img v-else :src="scope.row.thumbUrl" alt="" />
		</div>
		<popoverText class="text" :line="2" :subText="dataFormat" :text="dataFormat"></popoverText>
		<ig-icon
			v-if="isShow"
			:class="disabled ? 'disabled icon' : 'icon'"
			:name="tableData.iconName || 'chakan'"
			@click="preview"
		></ig-icon>
	</div>
</template>
<script>
import popoverText from '@/components/tools/popoverText.vue';
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	components: {
		popoverText,
	},
	data() {
		return {
			textStyle: {
				'justify-content': 'flex-start',
			},
		};
	},
	computed: {
		dataFormat() {
			let { scope, tableData } = this;
			if (tableData.dataFormat) {
				return tableData.dataFormat(scope.row[tableData.bind], scope.row);
			} else {
				return scope.row[tableData.bind] || '-';
			}
		},
		dataStyle() {
			let { tableData } = this;
			return tableData.dataStyle;
		},
		disabled(self) {
			if (typeof self.tableData.iconDisabled === 'function') {
				return self.tableData.iconDisabled(self.scope.row);
			}
			return self.tableData.iconDisabled;
		},
		isShow(self) {
			if (typeof self.tableData.iconShow === 'function') {
				return self.tableData.iconShow(self.scope.row);
			}
			return self.tableData.iconShow || true;
		},
	},
	methods: {
		preview() {
			if (!this.disabled) this.tableData.preview && this.tableData.preview(this.scope.row);
		},
		videoPreview(url) {
			this.tableData.videoPreview(url);
		},
	},
};
</script>
<style lang="scss" scoped>
.preview {
	display: flex;
	align-items: center;
	padding-right: 20px;

	img {
		height: 60px;
	}
	.text {
		margin: 0 10px;
	}
	.icon {
		&:hover {
			color: #3da1ff;
		}
		cursor: pointer;
	}

	.disabled {
		color: #c0c4cc !important;
		cursor: not-allowed;
	}
	.video {
		width: 80px;
		height: 80px;
		position: relative;

		.controls {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			cursor: pointer;
			text-align: center;
			color: #fff;
			opacity: 0;
			font-size: 20px;
			background-color: rgba(0, 0, 0, 0.5);
			transition: opacity 0.3s;
			display: flex;
			justify-content: space-evenly;
			align-items: center;

			i {
				font-size: 25px;
			}
		}

		.controls:hover {
			opacity: 1;
		}
	}
}
</style>
